import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useSEOKeywords } from '../../hooks/useSEOKeywords';
import { SEARCH_PARAM_KEY_TYPE } from '../../constants/searchParamKeys';
import { useDynamicConfigs } from '../../hooks/useDynamicConfigs';
export const InnerLink = () => {
    const [searchParams] = useSearchParams();
    const { collection } = useDynamicConfigs();
    const { handle, medium } = useParams();
    const { kw1, kw3 } = useSEOKeywords();
    const type = searchParams.get(SEARCH_PARAM_KEY_TYPE);
    if (handle === undefined || type === null)
        return null;
    const title = collection?.title ?? 'Search';
    let pathname = `/collections/${handle}`;
    if (medium !== undefined) {
        pathname += `/${medium}`;
    }
    return (React.createElement("p", { className: "text:center fz:14 px:14 pb:32" },
        "Looking for additional ",
        title,
        " ",
        kw1,
        " ideas? Select from ",
        React.createElement(Link, { to: { pathname }, className: "text:underline" }, `inspiring ${title} ${kw3} here >>`)));
};
